import request from '@/utils/request'

/**
 * 获取字典列表数据
 */
export const getDictLists = (data) => {
    return request({
        url: '/dict/lists',
        params: data
    })
}

/**
 * 获取字典选项列表数据
 */
export const getDictOptionLists = (data) => {
    return request({
        url: '/dict/option/lists',
        params: data
    })
}

/**
 * 字典管理-详情
 */
export const getDictDetail = (id) => {
    return request({
        url: `/dict/${id}`
    })
}

/**
 * 字典-修改
 */
export const putDict = (data) => {
    return request({
        url: '/dict/manage',
        method: 'PUT',
        data
    })
}

/**
 * 字典-添加
 */
export const addDict = (data) => {
    return request({
        url: '/dict/manage',
        method: 'POST',
        data
    })
}

/**
 * 字典-删除
 */
export const delDict = (id) => {
    return request({
        url: `/dict/${id}`,
        method: 'DELETE'
    })
}

/**
 * 字典-刷新缓存
 */
export const dictRefresh = () => {
    return request({
        url: '/dict/refresh/cache',
        method: 'DELETE'
    })
}

// 批量启用
export const batchEnable = (data) => {
    return request({
        url: '/dict/manage',
        method: 'PATCH',
        data: {
            method: 'batch_enable',
            data
        }
    })
}

// 批量禁用
export const batchDisable = (data) => {
    return request({
        url: '/dict/manage',
        method: 'PATCH',
        data: {
            method: 'batch_disable',
            data
        }
    })
}

// 批量排序
export const batchSort = (data) => {
    return request({
        url: '/dict/manage',
        method: 'PATCH',
        data: {
            method: 'batch_update_order',
            data
        }
    })
}
